import { operatorCarriesValue } from '@payaca/gql-helpers';

import { CustomFieldConditionExtra } from './CustomFieldConditionExtraPicker';
import type { CustomFieldPickerNode } from './customFieldConditionPickerNodes';

export type CustomFieldConditionExtraValidator = (
  extra: CustomFieldConditionExtra
) => Record<string, string> | null;

/**
 * Re-uses the same per-type validation that the Custom Fields sidebar runs
 * (`CustomFieldDefinition.validateValue`, AJV-backed) against the
 * comparisonValue authored on a customFieldCondition guard. Without this
 * the back-end was the first layer to reject e.g. a non-email string in an
 * email field, and the user's edit silently failed at save time.
 */
export const validateCustomFieldConditionExtra = (
  extra: CustomFieldConditionExtra,
  nodesByPath: Map<string, CustomFieldPickerNode>
): Record<string, string> | null => {
  if (extra.operator === '' || !operatorCarriesValue(extra.operator)) {
    return null;
  }
  if (
    extra.comparisonValue === undefined ||
    extra.comparisonValue === null ||
    extra.comparisonValue === ''
  ) {
    return null;
  }

  const node = nodesByPath.get(extra.fieldPath);
  if (!node) return null;

  const result = node.definition.validateValue(extra.comparisonValue);
  if (result.isValid) return null;

  return {
    comparisonValue:
      result.validationMessages.filter(Boolean).join('. ') ||
      'Value is not valid for this field',
  };
};
